import { useSearchParams } from 'react-router-dom'
import { PlaceScanFlow } from '../components/PlaceScanFlow'
import { StoreScreen } from '../components/StoreScreen'

/** F5.9 — Move inside the store (shares the put-away scan screen; sends move_bags). */
export function MovePage() {
  const [params] = useSearchParams()
  return (
    <StoreScreen title="store.move">
      {(state) => <PlaceScanFlow state={state} mode="MOVE" initialLocationId={params.get('to')} />}
    </StoreScreen>
  )
}
